import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

export const TitleIcon = styled(ReactSVG)`
  svg {
    width: 70px;
    height: auto;
  }

  margin-bottom: 10px;
`;

export const Title = styled.div`
  font-size: 22px;
  color: ${({ theme }) => theme.elements.textGrey};
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const Subtext = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.elements.textLightGrey};
  text-align: left;
  white-space: pre-wrap;
  margin-bottom: 1rem;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 1rem;
`;
